import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const app = initializeApp({
  apiKey: 'AIzaSyBL9moxg4vEgSmVDadQqlCtlC3BYFfWepk',
  authDomain: 'timelylimit.firebaseapp.com',
  databaseURL: 'https://timelylimit.firebaseio.com',
  projectId: 'timelylimit',
  storageBucket: 'timelylimit.appspot.com',
  messagingSenderId: '240332042280',
  appId: '1:240332042280:web:c27061f949157dcea3c51d',
  measurementId: 'G-D1JKQJ68W4',
})

const db = getFirestore(app)
const functions = getFunctions(app, 'asia-northeast1')
const auth = getAuth(app)
const storage = getStorage(app)

if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectStorageEmulator(storage, 'localhost', 9199)
}

export { app, auth, db, functions, storage }
